<template>
    <div class="flex-row start middle">
        <el-switch v-model="Data" :active-value="options[1].Value" :inactive-value="options[0].Value"
            @change="handleChange">
        </el-switch>
        <div class="line1" style="margin-left: 6px; color: #666">
            {{ options[Data].Title }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: Number,
        config: Object,
        options: {
            type: Array,
            default: () => {
                return [
                    { Value: 0, Title: "删除" },
                    { Value: 1, Title: "启用" }
                ];
            }
        }
    },
    methods: {
        handleChange(val) {
            this.$emit("change", val);
        }
    },
    data() {
        return { Data: this.value || 0 };
    }
};
</script>